import type { FC } from 'react';

import CarrierClaimsAddressContainer from '../carrier-claims-address-container';

interface CarrierClaimsAddressTabProps {
  carrierKey?: number;
}

const CarrierClaimsAddressTab: FC<CarrierClaimsAddressTabProps> = ({ carrierKey }) => {
  return (
    <div className="h-100">
      <div className="pb-10">
        <CarrierClaimsAddressContainer carrierKey={carrierKey} />
      </div>
    </div>
  );
};

export default CarrierClaimsAddressTab;
